/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Study_Field_LabelInputs */

const en_candidate_profile_study_field_label = /** @type {(inputs: Candidate_Profile_Study_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field of Study`)
};

const de_candidate_profile_study_field_label = /** @type {(inputs: Candidate_Profile_Study_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studienfach`)
};

/**
* | output |
* | --- |
* | "Field of Study" |
*
* @param {Candidate_Profile_Study_Field_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_study_field_label = /** @type {((inputs?: Candidate_Profile_Study_Field_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Study_Field_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_study_field_label(inputs)
	return en_candidate_profile_study_field_label(inputs)
});